import {TiersResponse} from "@irati/types"
import theme from "@irati/ui/src/global/theme"
import {GridCentered, GridCenteredProps} from "@irati/ui/src/Layout"
import {Body} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import topupService from "@irati/wallet/services/TopUp"
import React, {FC, useEffect, useState} from "react"
import ServiceFeeCard from "./ServiceFeeCard"

interface Props {
  purchaseCurrency: string
  serviceFeesTiers: TiersResponse[]
  maxColumns?: GridCenteredProps["maxColumns"]
  currentTier?: string
}

const ServiceFeesCards: FC<Props> = ({purchaseCurrency, serviceFeesTiers, maxColumns, currentTier}) => {
  const [waivedTiers, setWaivedTiers] = useState(false)

  useEffect(() => {
    topupService.serviceFeesWaived().then((serviceFeeWaived) => setWaivedTiers(serviceFeeWaived))
  }, [])

  return (
    <>
      {waivedTiers && (
        <Body color={theme.colors.greys.black} marginBottom={theme.spacing.two}>
          <FormattedMessage id="wallet.reward.admin.topup.serviceFeeOffer" />
        </Body>
      )}

      <GridCentered maxColumns={maxColumns}>
        {serviceFeesTiers?.map((tier, index, tiers) => (
          <ServiceFeeCard
            {...tier}
            key={tier.uuid}
            isFirst={index === 0}
            isLast={index === tiers.length - 1}
            isCurrent={tier.uuid === currentTier}
            purchaseCurrency={purchaseCurrency}
          />
        ))}
      </GridCentered>
    </>
  )
}

export default ServiceFeesCards
